import english from './en-GB.json';
import spanish from './es-ES.json';
import american from './en-US.json';

// ToDo (CLECOM-5699): Remove once translation pattern has been implemented.

export const messages = {
    'en-GB': english,
    'es-ES': spanish,
    'en-US': american
};
